import { GetSessionsToRescheduleEndpoint } from '@kouto/types';
import { z } from 'zod';
import { get } from '../api';

import ApiResponse from '../types/ApiResponse';

const fetchRescheduleSessions = async (
  url: string,
  { brandId }: { brandId: string },
) => {
  const response = await get<
    ApiResponse<z.infer<typeof GetSessionsToRescheduleEndpoint.responseSchema>>
  >(url, {
    headers: {
      'Kouto-Brand-Id': brandId,
      'Way-Brand-Id': brandId,
    },
  });

  return response.data;
};

export default fetchRescheduleSessions;
